import { render, staticRenderFns } from "./lineup_singleTeam_old1.vue?vue&type=template&id=4542c4f6&scoped=true"
import script from "./lineup_singleTeam_old1.vue?vue&type=script&lang=js"
export * from "./lineup_singleTeam_old1.vue?vue&type=script&lang=js"
import style0 from "./lineup_singleTeam_old1.vue?vue&type=style&index=0&id=4542c4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4542c4f6",
  null
  
)

export default component.exports